import SyncOrderView from "./SyncOrderView";
export default SyncOrderView;
